export default __webpack_public_path__ + "static/media/LizKanePortrait.c6d0756e.png";